import { useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'

import { appRoutes, authRoutes } from 'routes'
import InfoMessage from 'components/ui/InfoMessage'
import { CenterDiv } from 'components/ui/Shared'
import { useTranslation } from 'hooks/useTranslation'

const IframeRedirect = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const { action } = useParams<{ action: string }>()

  useEffect(() => {
    if (action === 'auth') {
      window.parent.location.href = authRoutes.views.login.path
    }
    if (!action || action === 'back') {
      window.parent.location.href = appRoutes.main.path
    }
  }, [history, action])

  return (
    <CenterDiv style={{ padding: '1rem' }}>
      <InfoMessage title={t('paymentRedirect.successMsg')} nature='success' />
    </CenterDiv>
  )
}

export default IframeRedirect
